import { Injectable } from '@angular/core';
import { SwCascaderOptions } from './sw-cascader';

@Injectable({
  providedIn: 'root'
})
export class SwCascaderService {

  /**
   * 将平级数据转化为树数据, datas：要转化为树结构的原始数据, keySelected选中节点的key值
   * @param datas  数据源
   * @param keySelected  选中的节点的key,将之的
   * @param id  主键
   * @param pid  父主键
   * @param text  显示字段
   * @param disabledNodeId 禁用字段 
   * @param selectChildren  最底层节点带复选框功能是否开启
   * @param allCanCheck  所有节点带复选框功能是否开启
   * @param radio  是否开启单选任一级节点功能
   * @param multiNodeIds  复选功能的选中节点的id
   */
  toNodeOptions(datas: any[], keySelected: string,id:string,pid:string,text:string,disabledNodeId:string,readonlyNodeId:any[],readonlySelfId:any[],selectChildren?:boolean,allCanCheck?:boolean,radio?:boolean,multiNodeIds?:any[]): SwCascaderOptions[]{
    let nodes:SwCascaderOptions[] = [];
    let num:number = 0;
    let index:number =0;
    for (let data of datas) {  //遍历平级数据，找到所有一级节点
      if (datas.filter(d => d[id] === data[pid]).length == 0 ) { //如果该数据的pid跟数据中的任何一个的id都不相同，说明判断该节点没有父级，则添加为根节点。
        if(disabledNodeId){  //如果要禁止的数据没有父节点,就不展示此根节点
          let array = disabledNodeId.split(',');//将禁止的节点id字符串 分割为数组
          if(array.indexOf(data.id)!= -1){
            continue
          }
        }
        nodes.push(new SwCascaderOptions());
        nodes[num].key = data[id];
        nodes[num].title = data[text];
        nodes[num].data = data;
        nodes[num].parent = null  //根节点的parent设置为null
        nodes[num].level = 1  //根节点的级数设置为第一级
        nodes[num].expanded = data.expanded  
        
        if(readonlyNodeId.length){  //如果要只读的数据没有父节点,就设置readonly = true;
          if(readonlyNodeId.indexOf(data.id)!= -1 || readonlyNodeId.indexOf(data.pid)!= -1){
            nodes[num].readonly = true;
            nodes[num].readonlyFrom = 'readonlyNodeId';
          }
        }

        if(readonlySelfId.length){  //如果要只读的数据没有父节点,就设置readonly = true;
          if(readonlySelfId.indexOf(data.id)!= -1){
            nodes[num].readonly = true;
            nodes[num].readonlyFrom = 'readonlySelfId';
          }
        }

        //如果要最底层节点带有复选框
        if(selectChildren){
          nodes[num].multiple = true;
        }
        //如果要所有节点带有复选框
        if(allCanCheck){
          nodes[num].checkbox = true;
          nodes[num].parent = data[pid];  //将上级数据的id存进去
        }
        //如果有已经选中的复选数据
        if(multiNodeIds && multiNodeIds.length){  //如果已经选中的数据有父节点
          nodes[num].selected = multiNodeIds.indexOf(data.id)!= -1
        }
        
        //单选任一级节点回显功能
        if (radio && keySelected != "" && keySelected == data[id]){  //在处理根节点时，如果有单选任一节点功能，且有回显数据时，要将此节点选中 
          nodes[num].selected = true;   //该节点选中    
        } 

        num++;
      }
    }
    //找到所有一级节点之后，再次遍历所有数据，找到该一级节点的所有子节点
    for (let node of nodes) {
      //依次为节点添加子节点， node:节点
      node.children = this.addNodeChildren(datas, node, keySelected,disabledNodeId,readonlyNodeId,readonlySelfId,index,selectChildren,allCanCheck,radio,multiNodeIds);
    }
    return nodes;
  }

  /**
   * 添加子节点，datas：要转化为树结构的原始数据, keySelected选中节点的key值，node:节点
   * @param datas  数据源
   * @param node  当前节点数据
   * @param keySelected  选中节点的key 单选功能默认回显的节点 id, 或者是 'default'默认选中不为只读或禁用的第一个节点
   * @param disabledNodeId  禁用的数据(该节点及其子节点不展示)
   * @param readonlyNodeId  只读的数据(该节点及其子节点展示但不能选择)
   * @param readonlySelfId  只读的数据(该节点展示但不能选择)
   * @param index  当前第几节点
   * @param selectChildren  是否开启最底层节点多选功能
   * @param allCanCheck  是否开启所有节点多选功能
   * @param radio  是否开启单选任一级节点功能
   * @param multiNodeIds  多选功能选中的节点的id(回显)
   * @param type  节点类型,来决定图标类型
   * @param initSelectedId  单选功能默认回显的节点 id, 或者是 'default'默认选中不为只读或禁用的第一个节点
   */
  addNodeChildren(datas: any[], node: SwCascaderOptions, keySelected: string, disabledNodeId:string,readonlyNodeId:any[],readonlySelfId:any[],index?:number,selectChildren?:boolean,allCanCheck?:boolean,radio?:boolean,multiNodeIds?:any[]): SwCascaderOptions[]{
    let num = 0;    //子集索引位置
    index++;
    node.children = [];
    for (let data of datas.filter(d => d.pid == node.key)) {  //找出所有当前节点的子节点， 
      if(disabledNodeId){
        let array = disabledNodeId.split(',');//将禁止的节点id字符串 分割为数组
        if(array.indexOf(data.id)!= -1){
          continue
        }
      }
    
      // if(data.id == disabledNodeId){
      //   continue
      // }
      node.children.push(new SwCascaderOptions());  //为当前节点添加子节点数据   
      if (keySelected != "" && keySelected == data.id){  //当前节点为选中的节点 
        node.expanded = true;   //展开选中节点的父节点  
        node.halfSelected = true  //父节点为半选
        node.children[num].selected = true;  //当前节点设置为选中   
      }    
      node.children[num].key = data.id;         //id值
      node.children[num].data = data;
      node.children[num].title = data.text;       //显示的文本值
      node.children[num].parent = node.key;       //设置当前子节点的父节点的id
      node.children[num].level = node.level+1;       //设置当前子节点的级数
      if(readonlyNodeId.length){  //如果要只读的数据没有父节点,就不展示此根节点
        //如果该节点的id或者是父级的id是只读,或者是父级节点已经设置为只读(由 readonlyNodeId 设置的),那么这个子节点就是只读
        if(readonlyNodeId.indexOf(data.id)!= -1  || readonlyNodeId.indexOf(data.pid)!= -1 || (node.readonly && node.readonlyFrom == 'readonlyNodeId')){
          node.children[num].readonly = true
        }
      }

      if(readonlySelfId.length){  //如果要只读的数据没有父节点,就不展示此根节点
        //如果该节点的id在数组中,那么这个子节点就是只读
        if(readonlySelfId.indexOf(data.id)!= -1){
          node.children[num].readonly = true
        }
      }

      //如果要最底层节点带有复选框
      if(selectChildren){
        node.children[num].multiple = true;
        if(multiNodeIds && multiNodeIds.length){  //如果已经选中的数据
          if(multiNodeIds.indexOf(data.id)!= -1){  //如果当前子节点已经被选中
            node.children[num].selected = true;  //将此节点设置为选中
            //且将选中节点的父节点展开
            node.expanded = true
            node.halfSelected = true  
          }
        }
      }
       //如果要所有节点带有复选框
       if(allCanCheck){
        node.children[num].checkbox = true;
        node.children[num].parent = data.pid;  //将上级数据的id存进去
        if(multiNodeIds && multiNodeIds.length){  //如果已经选中的数据
          if(multiNodeIds.indexOf(data.id)!= -1){  //如果当前子节点已经被选中
            node.children[num].selected = true;  //将此节点设置为选中
            //且将选中节点的父节点展开
            node.expanded = true 
            node.halfSelected = true  
          }
        }
      }
        
      //单选任一级节点回显功能
      if (radio && keySelected != "" && keySelected == data.id){  //在处理根节点时，如果有单选任一节点功能，且有回显数据时，要将此节点选中 
        node.children[num].selected = true;   //该节点选中    
      } 

      node.children[num].children = this.addNodeChildren(datas, node.children[num], keySelected, disabledNodeId,readonlyNodeId,readonlySelfId,index,selectChildren,allCanCheck,radio,multiNodeIds); //递归为子节点继续添加子节点
      if (keySelected != "" && node.children[num].expanded == true){  //将所有展开节点的父节点都展开
        node.expanded = true; 
        node.halfSelected = true 
      }  
           

      num++;
    }
    return node.children;
  }
}
